import { useMutation } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import { EntryDto } from '../../../api/generated/v2/generated/data-contracts';

export const useRegisterTimeHours = () => {
    return useMutation({
        mutationFn: (entries: EntryDto[]) => ApiCallsV2.registerTimeHours(entries),
    });
};
